import { AnalyticsHelperService } from './../../services/analytics-helper.service';
import { MailOfferFormModalComponent } from './../evsb-mail-offer-form/evsb-mail-offer-form-modal.component';
import { LanguageService } from './../../../../core/language/services/language.service';
import { Router } from '@angular/router';
import { ButtonSizeEnum } from '../../libs/component-lib/enums/button-size.enum';
import { VirtualCheckupModalComponent } from '../evsb-virtual-checkup/virtual-checkup-modal.component';
import { take, takeUntil } from 'rxjs/operators';
import { EvsbFinalInvoiceService } from './evsb-final-invoice.service';
import { Observable, Subject } from 'rxjs';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { EvsbFinalInvoiceModel } from './evsb-final-invoice.model';
import { ModalPresenter } from '../../libs/component-lib/components/modal/presenter/modal-presenter.service';
import { ProductsStoreService } from '../../stores/products-store.service';
import { flyInOut } from '../../libs/animations/fly-animations';
import { AnalyticsService } from '@app/shared/modules/analytics/services/analytics.service';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-evsb-final-invoice',
  templateUrl: './evsb-final-invoice.component.html',
  styleUrls: ['./evsb-final-invoice.component.scss'],
  animations: [flyInOut],
})
export class EvsbFinalInvoiceComponent implements OnInit, OnDestroy {
  public model$: Observable<EvsbFinalInvoiceModel>;
  public btnSmall = ButtonSizeEnum.small;

  private notifier = new Subject<void>();

  constructor(
    private modalService: ModalPresenter,
    private pageService: EvsbFinalInvoiceService,
    private products: ProductsStoreService,
    private analyticsService: AnalyticsService,
    private analyticsHelperService: AnalyticsHelperService,
    private router: Router,
    private language: LanguageService,
    private title: Title,
    private translate: TranslateService
  ) {
    this.translate.onLangChange.pipe(takeUntil(this.notifier)).subscribe(() => {
      this.title.setTitle(this.translate.instant('modules.evsb.pages.title.finalInvoice'));
    });
  }

  ngOnInit(): void {
    this.analytics();
    this.model$ = this.pageService.getModel$();
  }

  ngOnDestroy(): void {
    this.notifier.next();
    this.notifier.complete();
  }

  editSolution() {
    this.analyticsCta('modify-simulation', undefined);
    this.router.navigate(['/product-overview'], { skipLocationChange: true });
  }

  onRequestVirtualCheckup() {
    this.model$.pipe(take(1)).subscribe((model) => {
      if (model.canRequestFinalInvoice) {
        const ref = this.modalService.open(VirtualCheckupModalComponent);
        const modal = ref.componentInstance as VirtualCheckupModalComponent;
        this.analyticsCta('quote-request', 'book-assesment');
      }
    });
  }

  onSendProposalToMailbox() {
    this.model$.pipe(take(1)).subscribe((model) => {
      if (model.canRequestFinalInvoice) {
        const ref = this.modalService.open(MailOfferFormModalComponent);
        const modal = ref.componentInstance as MailOfferFormModalComponent;
        this.analyticsCta('quote-request', 'send-email');
      }
    });
  }

  private analytics() {
    this.analyticsHelperService.analyticsWorkflowStep('quote-request-submit', {
      event: 'b-to-b-ev-simulator-quote-request-submit',
      withResult: true,
    });
  }

  private analyticsCta(action: string, solution: string) {
    this.analyticsService.push({
      event: 'cta',
      eventCategory: 'b-to-b-ev-simulator',
      eventAction: action,
      eventLabel: solution,
    });
  }
}
